import { createSlice } from "@reduxjs/toolkit";

export const mockSurveillanceAuthenticatedDevices = [
  {
    deviceId: "0c:b6:d2:fa:45:31",
    macAddress: "0c:b6:d2:fa:45:31",
    status: "success",
    message: "Success",
  },
];

export const surveillanceAuthenticatedDevicesSlice = createSlice({
  name: "surveillanceAuthenticatedDevices",
  initialState: {
    resource: "surveillanceAuthenticate",
    batchData: [...mockSurveillanceAuthenticatedDevices],
    data: [...mockSurveillanceAuthenticatedDevices],
  },
});

export default surveillanceAuthenticatedDevicesSlice.reducer;
